/**
 * Schedules non-critical work after first paint / when the main thread is idle.
 * Falls back to rAF + setTimeout(0) on browsers without requestIdleCallback.
 */
export function runOnIdle(callback: () => void, timeout = 2000) {
  if (typeof window !== "undefined" && typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(callback, { timeout });
    return;
  }

  requestAnimationFrame(() => setTimeout(callback, 0));
}

/**
 * Yields to the browser so it can paint the current frame (improving INP),
 * https://web.dev/articles/optimize-long-tasks
 */
export function yieldToMain(callback: () => void) {
  setTimeout(callback, 0);
}
